import React, { useEffect } from "react";
// import ScrollToTop from "../customHooks/scrollToTop";
import bannerVec from "../assets/image/home/whybannervec.png";
import introVec from "../assets/image/home/introvec.png";
import axios from "axios";
import { Icon } from "@iconify/react";
import { useState } from "react";

import { toast } from "react-toastify";
import Button from "../components/shared/button";
import Countdown from "../customHooks/countdown";
import Slider from "react-slick";
import CookieConsent from "react-cookie-consent";
import { Helmet } from "react-helmet";
import ScrollToTop from "../customHooks/scrollToTop";
import Image from "../assets/image/image.png";

const COURSES = [
  {
    id: 1,
    tab: "Module 1",
  },

  {
    id: 2,
    tab: "Module 2",
  },

  {
    id: 3,
    tab: "Module 3",
  },

  {
    id: 4,
    tab: "Module 4",
  },

  {
    id: 5,
    tab: "Module 5",
  },

  {
    id: 6,
    tab: "Module 6",
  },

  {
    id: 7,
    tab: "Module 7",
  },

  {
    id: 8,
    tab: "Module 8",
  },

  {
    id: 9,
    tab: "Module 9",
  },

  {
    id: 10,
    tab: "Module 10",
  },
];
const Home = () => {
  ScrollToTop();
  const targetDate = new Date("2023-11-13T23:59:59");
  const [activeTab, setActiveTab] = useState("Module 1");

  const [email, setEmail] = useState("");
  // ScrollToTop();
  const handleEmailChange = (event) => {
    // Update the email state when the input value changes
    setEmail(event.target.value);
  };

  const handleSubscribeClick = async () => {
    console.log(email);

    try {
      if (email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {
          toast.error("Please enter a valid email address");
          return; // Don't proceed if the email is not valid
        }

        const url = `${process.env.REACT_APP_SERVER_URL}/email/sendemail`;
        const res = await axios.post(url, {
          email: email,
        });

        setEmail("");

        toast.success("Successfully Subscribed");
        console.log("email sent", res);
      } else {
        toast.warn("Please Enter Email to Subscribe");
      }
    } catch (error) {
      setEmail("");
      console.log(error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message, { toastId: "emailError" });
      } else {
        toast.error(error.message, { toastId: "emailError" });
      }
    }
  };

  // Slider

  function SampleNextArrow(props) {
    const { className, style, onClick, image } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          backgroundImage: `url(${image})`,
          backgroundSize: "contain",
          height: 50,
          width: 50,
          backgroundRepeat: "no-repeat",
          marginRight: 30,
          right: -60,
          top: 100,
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick, image } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          backgroundImage: `url(${image})`,
          backgroundSize: "contain",
          height: 50,
          width: 50,
          backgroundRepeat: "no-repeat",
          marginRight: 30,
          left: -60,
          top: 100,
        }}
        onClick={onClick}
      />
    );
  }

  var settings = {
    infinite: false,
    speed: 800,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    dots: false,
    nextArrow: <SampleNextArrow image="../../assests/images/Next_Arrow.png" />,
    prevArrow: <SamplePrevArrow image="../../assests/images/Back_Arrow.png" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },

      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        {/* <title>
          Simplifying government contracts Simpli RFP, for simple effiicent
          growth
        </title> */}
        <meta
          name="description"
          content={
            "Experience excellence through simplified government contracts. We streamline your tasks, so you can focus on what truly matters - your business success!"
          }
        />

        <meta
          property="og:title"
          content="Government Contracts Simplified - Simpli RFP"
        />
        <meta
          property="og:description"
          content={
            "Experience excellence through simplified government contracts"
          }
        />
        <meta property="og:image" content={Image} />
      </Helmet>
      <div className="whyUs-sec">
        <div className="whyUs-banner">
          <video className="hero-bg-video" muted autoPlay playsInline loop>
            <source src="../../assests/videos/hero.mp4" type="video/mp4" />
          </video>

          <div className="left d-flex flex-column justify-content-center">
            {/*
            <h1 className="mb-4">Redefining RFP Management With Excellence</h1>
          */}
            {/* <h1 className="mb-4">Navigate Government Contracts with Ease.</h1> */}
            <h1 className="mb-4">
              Simplifying government contracts to enable business growth.
            </h1>

            {/* <p>
              AI-driven solutions redefining efficiency and success in tender
              management!
            </p> */}
            <p>
              Simple. Efficient. Growth. <br />
              Powered by AI
            </p>
          </div>
        </div>

        <div className="intro-sec">
          <div className="left">
            <img
              src="../../assests/images/mockup.png"
              alt="Government contracts simplified"
            />
          </div>
          <div className="right">
            {/* <h3>
              Who Is <span className="text-cyan ">Simpli RFP</span>?
            </h3> */}

            <p>
              At Simpli RFP, we revolutionize the understanding of{" "}
              <b>government contracting</b>. Our advanced AI software transforms
              these intricate agreements into clear, comprehensible formats,
              stripping away any complexity. We assert that knowledge is the
              ultimate power lever. Our mission is steadfast: to eradicate
              contract confusion, empowering businesses to confidently seize new
              opportunities without hesitation.
              <b>
                Whether it's deciphering intricate terms or managing the
                subtleties of Contracted Out Services, Simpli RFP is your
                trusted partner in understanding and optimizing government
                contracting
              </b>
              .
            </p>
          </div>
        </div>

        <div className="why-card-sec">
          <div className="title-wrapper">
            <h3>
              Your Gateway to unmatched, government contract opportunities.
            </h3>
          </div>

          <div className="cards-wrapper">
            <div className="simplicard">
              <div className="card-image-wrapper">
                <img
                  className="setting"
                  src="../../assests/icon11.png"
                  alt=""
                />
                <img
                  className="file"
                  src="../../assests/icon1.png"
                  alt="Government contracts simplified"
                />
              </div>
              <h5 className="card-title">Optimize Procurement</h5>
              <p>
                Enhances RFP Evaluation <br /> and Response
              </p>
            </div>

            <div className="simplicard">
              <div className="card-image-wrapper">
                <svg
                  className="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="98"
                  height="99"
                  viewBox="0 0 98 99"
                  fill="none"
                >
                  <path
                    d="M49.1854 87.6757C70.1724 87.6757 87.1857 70.6624 87.1857 49.6754C87.1857 28.6884 70.1724 11.675 49.1854 11.675C28.1984 11.675 11.1851 28.6884 11.1851 49.6754C11.1851 70.6624 28.1984 87.6757 49.1854 87.6757Z"
                    fill="white"
                    class="svg-elem-1"
                  ></path>
                  <path
                    d="M82.3791 31.1589C86.8593 39.1913 88.2732 48.5764 86.3581 57.5723C84.4431 66.5681 79.3293 74.5636 71.9658 80.0748C64.6024 85.5859 55.4895 88.2383 46.3187 87.5396C37.1478 86.8409 28.5419 82.8387 22.0983 76.2757C15.6548 69.7127 11.8112 61.0348 11.281 51.8526C10.7508 42.6705 13.57 33.6079 19.2154 26.3469C24.8608 19.0858 32.9488 14.1197 41.9783 12.3701C51.0078 10.6205 60.3654 12.2064 68.3142 16.8334"
                    stroke="#32C4C0"
                    stroke-width="3.47495"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="svg-elem-2"
                  ></path>
                  <path
                    d="M95.9836 49.6058C95.9823 60.7817 91.9979 71.5913 84.7456 80.0945C77.4933 88.5977 67.4478 94.2378 56.4121 96.0026C45.3764 97.7673 34.073 95.5412 24.5306 89.7236C14.9882 83.9061 7.83154 74.8781 4.34511 64.2599C0.858678 53.6417 1.27072 42.1285 5.50728 31.7867C9.74384 21.445 17.5275 12.9516 27.4614 7.83112C37.3953 2.71061 48.8289 1.29817 59.7102 3.8473C70.5915 6.39643 80.2081 12.7402 86.834 21.7401"
                    stroke="#1F2D5C"
                    stroke-width="3.47495"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="svg-elem-3"
                  ></path>
                  <path
                    d="M68.9722 24.5531L88.1505 22.5376L86.135 3.35938M73.4567 50.2261H48.986V19.2399M48.986 80.7309V74.0503M23.3618 50.2261H18.0503"
                    stroke="#1F2D5C"
                    stroke-width="3.47495"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="svg-elem-4"
                  ></path>
                  <path
                    d="M48.9861 56.7189C52.5721 56.7189 55.4791 53.8119 55.4791 50.226C55.4791 46.64 52.5721 43.733 48.9861 43.733C45.4002 43.733 42.4932 46.64 42.4932 50.226C42.4932 53.8119 45.4002 56.7189 48.9861 56.7189Z"
                    fill="#32C4C0"
                    class="svg-elem-5"
                  ></path>
                  <path
                    d="M71.2311 72.9228C72.6513 72.9228 73.8026 71.7716 73.8026 70.3514C73.8026 68.9312 72.6513 67.7799 71.2311 67.7799C69.811 67.7799 68.6597 68.9312 68.6597 70.3514C68.6597 71.7716 69.811 72.9228 71.2311 72.9228Z"
                    fill="#32C4C0"
                    class="svg-elem-6"
                  ></path>
                  <path
                    d="M26.7399 32.5786C28.1601 32.5786 29.3114 31.4273 29.3114 30.0071C29.3114 28.587 28.1601 27.4357 26.7399 27.4357C25.3197 27.4357 24.1685 28.587 24.1685 30.0071C24.1685 31.4273 25.3197 32.5786 26.7399 32.5786Z"
                    fill="#32C4C0"
                    class="svg-elem-7"
                  ></path>
                  <path
                    d="M26.7399 72.9228C28.1601 72.9228 29.3114 71.7716 29.3114 70.3514C29.3114 68.9312 28.1601 67.7799 26.7399 67.7799C25.3197 67.7799 24.1685 68.9312 24.1685 70.3514C24.1685 71.7716 25.3197 72.9228 26.7399 72.9228Z"
                    fill="#32C4C0"
                    class="svg-elem-8"
                  ></path>
                </svg>
              </div>
              <h5 className="card-title">Time Saving</h5>
              <p>75% Time Reduction</p>
            </div>

            <div className="simplicard ">
              <div className="card-image-wrapper efficiency">
                <svg
                  class=""
                  checkanimation=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="102"
                  height="100"
                  viewBox="0 0 102 100"
                  fill="none"
                >
                  <path
                    d="M66.5858 89.1267L68 90.5409L69.4142 89.1267L92.7125 65.8284L95.1716 68.2875L68 95.4591L55.8284 83.2875L58.2875 80.8284L66.5858 89.1267Z"
                    stroke="black"
                    stroke-width="4"
                    class="svg-elem-1"
                  ></path>
                  <path
                    d="M48.8677 90.9208C38.5161 91.3597 28.347 88.095 20.1853 81.7126C12.0237 75.3301 6.40397 66.2478 4.33475 56.0956C2.26552 45.9434 3.88229 35.3861 8.89487 26.3185C13.9074 17.2508 21.9877 10.2665 31.6853 6.61905C41.3829 2.97158 52.0631 2.89978 61.8089 6.41651C71.5547 9.93325 79.7281 16.8083 84.8621 25.8077C89.9962 34.8071 91.7548 45.3417 89.8222 55.5208"
                    stroke="#1F2D5C"
                    stroke-width="6.47"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="svg-elem-2"
                  ></path>
                  <circle
                    cx="48.5"
                    cy="49.5"
                    r="19.5"
                    stroke="#32C4C0"
                    stroke-width="6"
                    class="svg-elem-3"
                  ></circle>
                  <circle
                    cx="48.5"
                    cy="49.5"
                    r="5.5"
                    fill="#1F2D5C"
                    stroke="#1F2D5C"
                    stroke-width="6"
                    class="svg-elem-4"
                  ></circle>
                </svg>
              </div>
              <h5 className="card-title">Boost Efficiency</h5>
              <p>Simplified Bidding for Faster, High-Quality Decisions</p>
            </div>

            <div className="simplicard">
              <div className="card-image-wrapper card_4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="89"
                  height="89"
                  viewBox="0 0 89 89"
                  fill="none"
                >
                  <path
                    d="M79.2002 79C80.3948 79 81.5916 79.5011 82.5124 80.4777C83.4407 81.4623 84.0002 82.8454 84.0002 84.3333V85H48.0002V84.3333C48.0002 82.8454 48.5597 81.4623 49.4881 80.4777C50.4089 79.5011 51.6057 79 52.8002 79H79.2002Z"
                    fill="#32C4C0"
                    stroke="#32C4C0"
                    stroke-width="8"
                  ></path>
                  <path
                    d="M43.8739 38.9902L44.225 38.6391L43.8764 38.2856L37.7174 32.0386L37.3663 31.6825L37.0103 32.0336L33.8427 35.1571L33.8399 35.1599C33.4794 35.5212 33.0511 35.8079 32.5796 36.0034C32.1082 36.199 31.6027 36.2997 31.0923 36.2997C30.5819 36.2997 30.0765 36.199 29.605 36.0034C29.1335 35.8079 28.7053 35.5212 28.3447 35.1599L28.3444 35.1596L25.2209 32.0361L25.2205 32.0357C24.8592 31.6752 24.5726 31.2469 24.377 30.7754C24.1814 30.304 24.0808 29.7985 24.0808 29.2881C24.0808 28.7777 24.1814 28.2723 24.377 27.8008C24.5726 27.3293 24.8592 26.9011 25.2205 26.5405L25.2209 26.5402L50.1209 1.6401L50.1213 1.63974C50.4818 1.27845 50.9101 0.991811 51.3816 0.796239C51.853 0.600667 52.3584 0.5 52.8689 0.5C53.3793 0.5 53.8847 0.600668 54.3562 0.796239C54.8276 0.991811 55.2559 1.27845 55.6165 1.63974L55.6168 1.6401L58.7403 4.76361C60.26 6.28325 60.2608 8.73639 58.7428 10.257C58.742 10.2579 58.7411 10.2587 58.7403 10.2595L55.6219 13.29L55.2595 13.6423L55.6156 14.0009L61.8626 20.2919L62.2165 20.6483L62.5713 20.2928C62.9319 19.9315 63.3601 19.6449 63.8316 19.4493C64.3031 19.2537 64.8085 19.153 65.3189 19.153C65.8293 19.153 66.3347 19.2537 66.8062 19.4493C67.2777 19.6449 67.7059 19.9315 68.0665 20.2928L68.0668 20.2931C69.5873 21.8136 69.5873 24.3126 68.0668 25.8331L67.7133 26.1866L68.0668 26.5402L74.2699 32.7432L74.6234 33.0967L74.977 32.7432L78.1005 29.6197C79.6207 28.0995 82.119 28.0992 83.6395 29.6188C83.6398 29.6191 83.6401 29.6194 83.6404 29.6197L86.7174 32.7407L86.7199 32.7432C88.2404 34.2636 88.2404 36.7626 86.7199 38.2831L61.8638 63.1391C60.3434 64.6596 57.8444 64.6596 56.3239 63.1391L53.2444 60.0596L53.2445 60.0596L53.2393 60.0546C52.8695 59.6953 52.5756 59.2655 52.3749 58.7905C52.1742 58.3156 52.0708 57.8053 52.0708 57.2897C52.0708 56.7741 52.1742 56.2637 52.3749 55.7888C52.5756 55.3139 52.8695 54.8841 53.2393 54.5248L53.2394 54.5248L53.2469 54.5172L56.3264 51.3937L56.675 51.0402L56.3239 50.6891L50.1209 44.4861L49.7674 44.1325L49.4138 44.4861L7.1365 86.7634L7.13614 86.7638C6.77559 87.1251 6.34732 87.4117 5.87585 87.6073C5.40439 87.8028 4.89898 87.9035 4.38855 87.9035C3.87812 87.9035 3.37271 87.8028 2.90125 87.6073C2.42978 87.4117 2.00151 87.1251 1.64096 86.7638L1.64059 86.7634C0.120128 85.2429 0.120128 82.744 1.64059 81.2235L43.8739 38.9902Z"
                    fill="#1F2D5C"
                    stroke="black"
                  ></path>
                </svg>
              </div>
              <h5 className="card-title">Profile Matching </h5>
              <p>Matching the right people for the right jobs</p>
            </div>

            <div className="simplicard">
              <div className="card-image-wrapper card_5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="89"
                  height="88"
                  viewBox="0 0 89 88"
                  fill="none"
                >
                  <path
                    d="M0.000244141 34.395V83.31C0.000244141 84.3204 0.552989 85.5091 1.46036 86.4204C2.36972 87.3318 3.56634 87.8865 4.55693 87.8865L80.6337 87.9063C81.6243 87.9063 82.813 87.3516 83.7243 86.4403C84.6357 85.5289 85.1904 84.3402 85.1904 83.3298V69.2635H67.9542C59.2371 69.2635 59.2371 53.018 67.9542 53.018H85.1904V34.4148L0.000244141 34.395ZM67.9542 56.5841C63.9919 56.5841 63.9919 65.6974 67.9542 65.6974H72.3722C70.5892 64.9446 69.3411 63.1814 69.3411 61.1408C69.3411 59.1002 70.5892 57.3369 72.3722 56.5841H67.9542ZM76.2157 56.5841C77.9988 57.3369 79.2469 59.1002 79.2469 61.1408C79.2469 63.1814 77.9988 64.9446 76.2157 65.6974H88.3602V56.5841H76.2157ZM74.294 59.7539C73.5015 59.7539 72.9072 60.3483 72.9072 61.1408C72.9072 61.9332 73.5015 62.5276 74.294 62.5276C75.0864 62.5276 75.6808 61.9332 75.6808 61.1408C75.6808 60.3483 75.0864 59.7539 74.294 59.7539Z"
                    fill="#1F2D5C"
                  ></path>
                  <path
                    d="M31.58 0L27.7167 30.8289H36.1961L45.9236 1.79097L31.58 0ZM49.7472 1.58493L39.9603 30.8289L69.6183 30.8487L76.4137 10.52L49.7472 1.58493ZM27.5384 3.69289L13.2938 5.24613L16.0872 30.8289H24.1506L27.5384 3.69289ZM4.55685 24.8854C2.27851 24.8854 0.756974 26.6289 0.342911 28.293C0.136869 29.1251 0.253758 29.7987 0.487536 30.1751C0.719332 30.5317 1.04028 30.8289 2.17945 30.8289H12.5013L11.8475 24.8854H4.55685ZM75.3637 24.8854L73.3826 30.8289H82.7931C82.278 29.8383 82.0601 28.7883 82.1987 27.7383C82.3374 26.7081 82.7337 25.777 83.2488 24.8854H75.3637Z"
                    fill="#32C4C0"
                  ></path>
                  <rect
                    x="0.500244"
                    y="0.5"
                    width="87.36"
                    height="86.9063"
                  ></rect>
                </svg>
              </div>
              <h5 className="card-title">Cost savings</h5>
              <p>Taxable credit </p>
            </div>

            <div className="simplicard">
              <div className="card-image-wrapper">
                <svg
                  width="89"
                  height="89"
                  viewBox="0 0 89 89"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M80.9969 4.90889H7.36358C6.71262 4.90889 6.08832 5.16748 5.62802 5.62778C5.16773 6.08808 4.90913 6.71237 4.90913 7.36333V80.9967C4.90913 81.6476 5.16773 82.2719 5.62802 82.7322C6.08832 83.1925 6.71262 83.4511 7.36358 83.4511H80.9969C81.6479 83.4511 82.2722 83.1925 82.7325 82.7322C83.1928 82.2719 83.4514 81.6476 83.4514 80.9967V7.36333C83.4514 6.71237 83.1928 6.08808 82.7325 5.62778C82.2722 5.16748 81.6479 4.90889 80.9969 4.90889ZM7.36358 0C5.4107 0 3.53781 0.775778 2.15691 2.15667C0.776022 3.53756 0.000244141 5.41046 0.000244141 7.36333V80.9967C0.000244141 82.9495 0.776022 84.8224 2.15691 86.2033C3.53781 87.5842 5.4107 88.36 7.36358 88.36H80.9969C82.9498 88.36 84.8227 87.5842 86.2036 86.2033C87.5845 84.8224 88.3602 82.9495 88.3602 80.9967V7.36333C88.3602 5.41046 87.5845 3.53756 86.2036 2.15667C84.8227 0.775778 82.9498 0 80.9969 0H7.36358Z"
                    fill="#1F2D5C"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M47.8496 59.1128C48.7417 58.5903 49.4811 57.843 49.994 56.9455C50.507 56.0479 50.7755 55.0315 50.7729 53.9978C50.7729 51.8059 49.5947 49.8988 47.8521 48.8827L50.3311 44.6439C51.9616 45.6001 53.3131 46.9669 54.2511 48.6081C55.189 50.2492 55.6806 52.1075 55.6768 53.9978C55.6796 55.8881 55.1871 57.7461 54.2483 59.3869C53.3095 61.0276 51.9572 62.3937 50.3262 63.3492L47.8472 59.1128H47.8496ZM61.1036 53.9978C61.1036 48.9244 58.8946 44.7052 55.9174 42.5527L58.7964 38.5765C63.2316 41.7844 66.0125 47.5892 66.0125 53.9978C66.0125 60.4039 63.2316 66.2111 58.7964 69.4215L55.9174 65.4453C58.8946 63.2903 61.1036 59.0711 61.1036 53.9978Z"
                    fill="#32C4C0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.3378 9.81775C12.6972 9.81775 12.0615 9.84229 11.4331 9.89629C10.9949 9.93019 10.5855 10.1278 10.2862 10.4497C9.987 10.7717 9.81989 11.1945 9.81812 11.634V79.254C9.81812 80.2161 10.6035 80.9966 11.578 80.9966H16.855C17.3194 80.9986 17.7655 80.8162 18.0955 80.4894C18.4255 80.1627 18.6122 79.7183 18.6148 79.254V66.5252L25.8235 69.5859C26.744 69.9786 27.8656 70.391 29.0364 70.5432C30.2268 70.6978 31.5792 70.5972 32.8359 69.8363C33.864 69.2183 34.715 68.3451 35.3063 67.3014C35.8976 66.2577 36.2092 65.0789 36.2108 63.8793V58.6489C36.2082 58.1846 36.0214 57.7402 35.6914 57.4135C35.3614 57.0867 34.9153 56.9043 34.4509 56.9063L29.0364 55.1612C29.0364 53.2344 30.7472 53.4185 32.6935 53.4185H34.4509C34.6811 53.4195 34.9091 53.3751 35.1221 53.2879C35.3351 53.2007 35.5289 53.0725 35.6923 52.9104C35.8557 52.7484 35.9856 52.5557 36.0745 52.3435C36.1635 52.1312 36.2098 51.9035 36.2108 51.6734V48.1856H38.1989C41.0116 48.1856 42.688 45.0808 41.1295 42.7613L36.2108 35.4471V32.4895C36.2108 19.9693 25.9708 9.81775 13.3353 9.81775H13.3378ZM30.9312 36.8485C30.93 37.1936 30.8607 37.5351 30.7273 37.8534C30.594 38.1717 30.3993 38.4606 30.1542 38.7036C29.9092 38.9466 29.6187 39.1389 29.2992 39.2695C28.9798 39.4002 28.6378 39.4666 28.2927 39.465C27.9476 39.4666 27.6056 39.4002 27.2862 39.2695C26.9668 39.1389 26.6763 38.9466 26.4312 38.7036C26.1862 38.4606 25.9914 38.1717 25.8581 37.8534C25.7248 37.5351 25.6555 37.1936 25.6542 36.8485C25.6555 36.5035 25.7248 36.162 25.8581 35.8437C25.9914 35.5254 26.1862 35.2365 26.4312 34.9935C26.6763 34.7505 26.9668 34.5582 27.2862 34.4276C27.6056 34.2969 27.9476 34.2305 28.2927 34.2321C28.6378 34.2305 28.9798 34.2969 29.2992 34.4276C29.6187 34.5582 29.9092 34.7505 30.1542 34.9935C30.3993 35.2365 30.594 35.5254 30.7273 35.8437C30.8607 36.162 30.93 36.5035 30.9312 36.8485Z"
                    fill="#32C4C0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M64.0981 71.7115C68.3345 68.3513 71.4369 61.8053 71.4369 53.9978C71.4369 46.1902 68.3345 39.6442 64.0981 36.2865L67.149 32.4404C72.7992 36.9197 76.3458 45.0268 76.3458 53.9978C76.3458 62.9688 72.7992 71.0758 67.149 75.5551L64.0981 71.7115Z"
                    fill="#1F2D5C"
                  />
                </svg>
              </div>
              <h5 className="card-title">Simplified language</h5>
              <p>Layman’s terms for all to understand</p>
            </div>
          </div>

          {/* <img
            className="pattern"
            src="../../assests/images/pattern.png"
            alt="Government contracts simplified"
          /> */}
        </div>

        <div className="learning_sec">
          {/* <h1>Simpli Learning Center</h1> */}
          <h1>Learning Center</h1>

          <div className="tab_section">
            {/* <h2>
              Begin your free journey! Discover the world of government
              contracts at your fingertips.
            </h2> */}
            <h2>
              Start your journey today! Explore the realm of government
              contracts, all accessible at your fingertips.
            </h2>

            <div className="tab_btns">
              {COURSES.map((item) => {
                return (
                  <>
                    <button
                      key={item.id}
                      onClick={() => setActiveTab(item.tab)}
                      className={`${
                        activeTab === item.tab ? "active_tab" : "tab_btn"
                      }`}
                    >
                      {item.tab}
                    </button>
                  </>
                );
              })}
            </div>

            <div className="tab_content">
              {activeTab === "Module 1" ? (
                <>
                  <div className="slider_container">
                    <h3>Introduction to Government Contracting</h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_1.png"
                              alt="Government contracts simplified"
                            />
                            <p>Overview of Government Procurement</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_2.png"
                              alt="Government contracts simplified"
                            />
                            <p>
                              The Role of Government Agencies in Contracting
                            </p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_3.png"
                              alt="Government contracts simplified"
                            />
                            <p>Types of Government Contracts</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_4.png"
                              alt="Government contracts simplified"
                            />
                            <p>Benefits of Government Contracting</p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </>
              ) : activeTab === "Module 2" ? (
                <>
                  <div className="slider_container">
                    <h3>Getting Started with Government Contracting</h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_8.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Business Registrations and Certifications</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_9.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Identifying Target Agencies and Markets</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_10.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>
                              Market Research and Opportunity Identification
                            </p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_11.jpg"
                              alt="Government contracts simplified"
                            />

                            <p>
                              Small Business Set-Asides and Socioeconomic
                              Programs
                            </p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </>
              ) : activeTab === "Module 3" ? (
                <>
                  <div className="slider_container">
                    <h3>Preparing Your Business for Government Contracting</h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_12.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Financial Readiness and Resources</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_13.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Building a Competitive Capability Statement</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_14.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Compliance with Contracting Requirements</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_15.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Securing Financing for Government Contracts</p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </>
              ) : activeTab === "Module 4" ? (
                <>
                  <div className="slider_container">
                    <h3> Finding and Evaluating Opportunities </h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_16.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>
                              Searching for Government Contract Opportunities
                            </p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_17.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>
                              Reading and Understanding Solicitation Documents
                              (RFPs/RFQs)
                            </p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_18.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Qualifying for Contract Eligibility</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_19.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Teaming and Partnering Opportunities</p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </>
              ) : activeTab === "Module 5" ? (
                <>
                  <div className="slider_container">
                    <h3>Preparing a Winning Bid</h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_5.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Developing a Competitive Pricing Strategy</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_9.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Writing a Winning Technical Proposal</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_12.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>
                              Project Scheduling, Milestones, and Critical Paths
                            </p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_7.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Addressing Quality Assurance and Safety Plans</p>
                          </div>
                        </div>
                        {/* 
                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_13.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>
                              Preparing for Bid Presentations and Interviews
                            </p>
                          </div>
                        </div> */}
                      </Slider>
                    </div>
                  </div>
                </>
              ) : activeTab === "Module 6" ? (
                <>
                  <div className="slider_container">
                    <h3>Submission and Post-Submission Activities</h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_15.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Completing Submission Forms and Requirements</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_7.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Meeting Submission Deadlines</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_3.png"
                              alt="Government contracts simplified"
                            />
                            <p>Post-Submission Follow-Up and Communication</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_9.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Handling Bid Protests and Disputes</p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </>
              ) : activeTab === "Module 7" ? (
                <>
                  <div className="slider_container">
                    <h3>Winning Strategies and Case Studies</h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_1.png"
                              alt="Government contracts simplified"
                            />
                            <p>Strategies for Increasing Win Rates</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_2.png"
                              alt="Government contracts simplified"
                            />
                            <p>Real-Life Case Studies of Successful Bids</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_3.png"
                              alt="Government contracts simplified"
                            />
                            <p>Competitive Analysis and Positioning</p>
                          </div>
                        </div>

                        <div className="card_center">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_6.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Types of Government Contracts</p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </>
              ) : activeTab === "Module 8" ? (
                <>
                  <div className="slider_container">
                    <h3>Contract Execution and Performance</h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_2.png"
                              alt="Government contracts simplified"
                            />
                            <p>Understanding Contract Terms and Conditions</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_11.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Compliance and Reporting Requirements</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_5.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Project Management and Execution</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_7.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Subcontractor and Vendor Management</p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </>
              ) : activeTab === "Module 9" ? (
                <>
                  <div className="slider_container">
                    <h3>Legal and Ethical Considerations</h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_3.png"
                              alt="Government contracts simplified"
                            />
                            <p>Ethics in Government Contracting</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_9.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Avoiding Common Legal Pitfalls</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_12.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Handling Disputes and Contract Changes</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_15.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>
                              Intellectual Property Rights in Government
                              Contracts
                            </p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </>
              ) : activeTab === "Module 10" ? (
                <>
                  <div className="slider_container">
                    <h3>Continuous Improvement and Resources</h3>

                    <div className="slider">
                      <Slider {...settings}>
                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_3.png"
                              alt="Government contracts simplified"
                            />
                            <p> Evaluating Bid Performance and Feedback</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_14.jpg"
                              alt="Government contracts simplified"
                            />
                            <p> Resources for Ongoing Learning and Support</p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_8.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>
                              Expanding Your Government Contracting Portfolio
                            </p>
                          </div>
                        </div>

                        <div className="card_center ">
                          <div className="slider_card">
                            <img
                              src="../../assests/images/Slider/Slider_6.jpg"
                              alt="Government contracts simplified"
                            />
                            <p>Staying Informed About Regulatory Changes</p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>

        <div className="intro-sec goodbye">
          <div className="right">
            <h3>
              Goodbye Lengthy Contracts, Hello
              <span className="text-cyan "> Simpli RFP.</span>
            </h3>
            <p>
              Are you tired of navigating through dense, technical contracts?
              Let Simpli RFP transform your experience. Say goodbye to baffling
              legalese and hello to clarity and simplicity. Our cutting-edge
              tool offers concise summaries, saving you invaluable time and
              energy. With Simpli RFP, the days of laborious contract reading
              are behind you. Embrace a new era of clear, understandable
              contracts, designed to make your life easier.
            </p>

            {/* <button className="btn-prime btn-gradient br-35   text-white text-capitalize">
              Read more
            </button> */}
          </div>
          <div className="left">
            <img
              src="../../assests/images/rightside.png"
              alt="Government contracts simplified"
            />
          </div>
        </div>

        <div className="newsletter-section  ">
          <div className="left news-left">
            <div className="content">
              {/* <div className="whatspecial">What Speciality</div> */}
              <h3>
                Stay Informed <span className="text-cyan ">& Secure Your</span>{" "}
                Spot for Updates!
              </h3>
              <p className="  text-center">
                Stay in the loop as exciting updates are on the horizon.
              </p>

              <div className="newsletter-module">
                <iframe
                  src="https://api.leadconnectorhq.com/widget/form/exze9bLEriqP564VO1hA"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    borderRadius: "35px",
                    boxShadow: "none",
                  }}
                  id="inline-exze9bLEriqP564VO1hA"
                  data-layout="{'id':'INLINE'}"
                  data-trigger-type="alwaysShow"
                  data-trigger-value=""
                  data-activation-type="alwaysActivated"
                  data-activation-value=""
                  data-deactivation-type="neverDeactivate"
                  data-deactivation-value=""
                  data-form-name="Join Now"
                  data-height="422"
                  data-layout-iframe-id="inline-exze9bLEriqP564VO1hA"
                  data-form-id="exze9bLEriqP564VO1hA"
                  title="Join Now"
                >
                  {" "}
                </iframe>
              </div>
            </div>
          </div>
          {/* <div className="right">
            <img src="../../assests/images/rightsidenews.png" alt="Government contracts simplified" />
          </div> */}
        </div>

        <div className="numbers-section d-none ">
          <div className="numbers-content v-center h-center ">
            <div className="first d-none">
              <h3>Strength In Numbers</h3>
              <h3>Strength In Numbers</h3>
            </div>
            <div className="second  v-center h-center ">
              <div className="number d-flex flex-column justify-content-center align-items-center">
                <h3 className="mb-3">Get ready to grow your business in ...</h3>
                <Countdown targetDate={targetDate} />
              </div>

              {/*<p>Local National & international speakers</p>*/}
            </div>
            <div className="second d-none">
              <div className="number">200,000+</div>

              <p>Local National & international speakers</p>
            </div>
          </div>
        </div>
      </div>
      <CookieConsent
        className="myConsent "
        location="bottom"
        buttonText="Allow Access"
        cookieName="SimpliCookie"
        onAccept={(acceptedByScrolling) => {
          if (acceptedByScrolling) {
            // triggered if user scrolls past threshold
            // alert("Accept was triggered by user scrolling");
          } else {
            // alert("Accept was triggered by clicking the Accept button");
          }
        }}
        enableDeclineButton
        onDecline={(test) => {
          console.log("userDenied cookies");
        }}
        style={{
          background: "linear-gradient(270deg, #32c4c0 0%, #1f2d5c 100%)",
          fontFamily: "DM Sans",
          fontSize: "16px",
          lineHeight: "120%",
          margin: "0px",
          display: "flex",
          alignItems: "center",
          columnGap: "30px",
          padding: "0px 20px",
        }}
        buttonStyle={{
          color: "#FFF",
          fontSize: "15px",
          fontWeight: 700,
          fontFamily: "DM Sans",
          background: "linear-gradient(90deg, #438c8a  0%, #1F2D5C 100%)",

          padding: "10px 0px",
          width: "250px",
          display: "flex",
          justifyContent: "center",
          margin: "8px 20px 15px 15px ",
        }}
        declineButtonStyle={{
          color: "#000",
          fontSize: "15px",
          fontWeight: 700,
          fontFamily: "Poppins  ",
          background: "#FFF",

          padding: "10px 0px",
          width: "250px",
          display: "flex",
          justifyContent: "center",
          margin: "15px 20px 8px 15px ",
        }}
        expires={150}
      >
        We use cookies and other similar technology to deliver our online
        services. Essential cookies are used to enable you to access and
        navigate our site. These are necessary and are always on. We also use
        functional,analytics and marketing cookies when we have your consent to
        do so. do so
      </CookieConsent>
    </div>
  );
};

export default Home;
